import React from 'react';

// Create a context with no initial values.
export const HotelContext = React.createContext();

export default HotelContext;
